var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observable } from "./subscriptions/Observable";
import { NotificationType } from './subscriptions/NotificationType';
var getEventData = function (notificationType, oldValue, newValue) {
    var friendly = function (nt) {
        if (nt === NotificationType.StateEnter) {
            return 'StateEnter';
        }
        else if (nt === NotificationType.StateLeave) {
            return 'StateLeave';
        }
        else {
            return 'Transition';
        }
    };
    return {
        notificationType: notificationType,
        event: friendly(notificationType),
        value: {
            new: newValue,
            old: oldValue
        }
    };
};
var Machina = /** @class */ (function () {
    /**
     * Create a Machina directly (useMachina is the way to fluently build a machina)
     *
     * @param initialState State to start out in
     * @param stateMap Full Map containing all transitions
     * @param machinaName Optional - useful when there are multiple substates.
     */
    function Machina(initialState, stateMap, machinaName) {
        var _this = this;
        this.stateMap = stateMap;
        this.started = false;
        /**
         * Observable event triggered each time a transition or state change occurs.
         */
        this.onEventObservable = new Observable();
        this.parent = null;
        this.transition = function (transitionEdge) { return __awaiter(_this, void 0, void 0, function () {
            var nodeState, transitionToFollow, nextState, previousState, result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.started) {
                            throw new Error("Must start() machina '" + this.name + "' before transition(...).");
                        }
                        nodeState = (this.stateMap.get(this.currentState));
                        transitionToFollow = nodeState.outEdges.find(function (t) { return t.on === transitionEdge; });
                        if (!(transitionToFollow === undefined)) return [3 /*break*/, 1];
                        return [2 /*return*/, null];
                    case 1:
                        if (!nodeState.onLeave) return [3 /*break*/, 3];
                        return [4 /*yield*/, nodeState.onLeave(nodeState, this)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        this.onEventObservable.notifyObservers(getEventData(NotificationType.StateLeave, this.currentState, transitionToFollow.nextState));
                        if (!(transitionToFollow.onTransition !== undefined)) return [3 /*break*/, 5];
                        return [4 /*yield*/, transitionToFollow.onTransition(this)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        this.onEventObservable.notifyObservers(getEventData(NotificationType.Transition, null, transitionToFollow.on));
                        nextState = this.stateMap.get(transitionToFollow.nextState);
                        previousState = this.currentState;
                        this.currentState = transitionToFollow.nextState;
                        if (!nextState.onEnter) return [3 /*break*/, 7];
                        return [4 /*yield*/, nextState.onEnter(nextState, this)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        result = {
                            current: transitionToFollow.nextState,
                            nestedMachinas: (_a = nextState.nestedMachinas) !== null && _a !== void 0 ? _a : [],
                            possibleTransitions: nextState.outEdges
                        };
                        this.onEventObservable.notifyObservers(getEventData(NotificationType.StateEnter, previousState, transitionToFollow.nextState));
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.currentState = initialState;
        this.machinaName = machinaName;
        // assign parent to nestedMachines
        this.stateMap.forEach(function (value) {
            if (Array.isArray(value.nestedMachinas)) {
                for (var _i = 0, _a = value.nestedMachinas; _i < _a.length; _i++) {
                    var nestedMachina = _a[_i];
                    nestedMachina.parent = _this;
                }
            }
        });
        return this;
    }
    Object.defineProperty(Machina.prototype, "name", {
        get: function () { return this.machinaName; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Machina.prototype, "isStarted", {
        get: function () { return this.started; },
        enumerable: false,
        configurable: true
    });
    Machina.prototype.start = function () {
        var currentNodeState = this.stateMap.get(this.currentState);
        this.onEventObservable.notifyObservers(getEventData(NotificationType.StateEnter, null, this.currentState));
        if (currentNodeState !== undefined && currentNodeState.onEnter) {
            currentNodeState.onEnter(currentNodeState, this);
        }
        this.started = true;
        return this;
    };
    Machina.prototype.subscribe = function (callback, notificationType, valueFilter, insertFirst, nextNotificationOnly) {
        if (notificationType === void 0) { notificationType = NotificationType.All; }
        if (valueFilter === void 0) { valueFilter = null; }
        if (insertFirst === void 0) { insertFirst = false; }
        if (nextNotificationOnly === void 0) { nextNotificationOnly = false; }
        return this.onEventObservable.add(callback, notificationType, valueFilter, insertFirst, nextNotificationOnly);
    };
    Machina.prototype.unsubscribe = function (observer) {
        return this.onEventObservable.remove(observer);
    };
    Machina.prototype.unsubscribeCallback = function (callback) {
        return this.onEventObservable.removeCallback(callback);
    };
    Object.defineProperty(Machina.prototype, "state", {
        get: function () {
            var _a;
            var nodeState = this.stateMap.get(this.currentState);
            return {
                current: this.currentState,
                nestedMachinas: (_a = nodeState.nestedMachinas) !== null && _a !== void 0 ? _a : [],
                possibleTransitions: nodeState.outEdges,
            };
        },
        enumerable: false,
        configurable: true
    });
    return Machina;
}());
export { Machina };
//# sourceMappingURL=Machina.js.map